import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/base/base.component';
import {
  FreezeCurrentCard,
  UnFreezeCurrentCard,
} from '@app/finxone-web-frontend/app/lib/actions/card.actions';
import { CloseModalPopupAction } from '@app/finxone-web-frontend/app/lib/actions/page-context.action';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CardState } from '@app/finxone-web-frontend/app/lib/state/card.state';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  BaseCssProperties,
  BaseWidgetProperties,
  CardInfoType,
  CardStatusType,
  NotificationWidgetConfig,
  ProviderClass,
  baseCssConfigStyle,
  commonContentStyleList,
  commonTextContentStyleList,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'finxone-platform-card-freeze-toggle-switch',
  templateUrl: './card-freeze-toggle-switch.component.html',
  styleUrl: './card-freeze-toggle-switch.component.css',
})
export class CardFreezeToggleSwitchComponent extends BaseComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public widgetConfigData!: BaseWidgetProperties;
  public iconStyle?: baseCssConfigStyle;
  public iconSize?: baseCssConfigStyle;
  public textContentStyle: baseCssConfigStyle;
  public showToggleSwitch = true;
  @Select(CardState.getCurrentCardDetail)
  public currentCardDetail$: Observable<CardInfoType>;
  public currentCardDetail: CardInfoType;
  public isDisabled = false;
  public isSwitchToggled: boolean;
  private redirectUrlOnSwitchChange: string;

  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<NotificationWidgetConfig>,
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super();
    this.currentCardDetail$.pipe(takeUntil(this.destroy$)).subscribe((currentCardDetail) => {
      this.currentCardDetail = currentCardDetail;
      const isCardFrozen = currentCardDetail.status === CardStatusType.FROZEN;
      if (this.isSwitchToggled !== undefined && this.isSwitchToggled === isCardFrozen) {
        this.isDisabled = false;
      }
    });
  }

  ngOnInit() {
    this.getWidgetCssConfig();
    this.widgetConfigData = this.dataIn.attri.widgetProperties;
    this.showToggleSwitch = this.widgetConfigData['freezeToggleSettings']?.type !== 'no-toggle';

    const urlToNavigate = this.widgetConfigData['urlToNavigate'];
    const zoneToNavigate = this.widgetConfigData['zoneToNavigate'];
    if (urlToNavigate && zoneToNavigate) {
      this.redirectUrlOnSwitchChange = this.configService.reRouteIfModal(zoneToNavigate, urlToNavigate);
    }
  }

  private getWidgetCssConfig() {
    this.contentStyle = this.configService.getSpecificBaseCssStyle(
      this.dataIn?.attri,
      commonContentStyleList,
    );

    this.textContentStyle = this.configService.getSpecificBaseCssStyle(
      this.dataIn?.attri,
      commonTextContentStyleList,
    );

    this.iconStyle = this.configService.getSpecificBaseCssStyle(this.dataIn?.attri, [
      BaseCssProperties.ICON_COLOR,
      BaseCssProperties.ICON_SIZE,
    ]);
  }

  public onToggleSwitchChange(freeze: boolean) {
    this.isSwitchToggled = freeze;
    this.isDisabled = true;
    if (freeze) {
      this.store.dispatch(new FreezeCurrentCard(this.currentCardDetail.id)).subscribe({
        error: () => {
          this.isDisabled = false;
        },
      });
    } else {
      this.store.dispatch(new UnFreezeCurrentCard(this.currentCardDetail.id)).subscribe({
        error: () => {
          this.isDisabled = false;
        },
      });
    }
    if (this.redirectUrlOnSwitchChange) {
      const isPrevModal = this.route.snapshot?.queryParams?.['isModal'] === 'true';
      this.store.dispatch(new CloseModalPopupAction(isPrevModal));
      this.router.navigate([this.redirectUrlOnSwitchChange]).then();
    }
  }

  protected readonly CardStatusType = CardStatusType;
}
